import { useState } from 'react';
import { useDebounce } from 'use-debounce';
import { useTeams } from 'app/domains/teams';
import { Context } from './TeamsContext';
export function TeamsProvider(props) {
    const { children } = props;
    const [sort, setSort] = useState({ id: 'name', order: 'asc' });
    const [search, setSearch] = useState('');
    const [searching, setSearching] = useState(false);
    const [debouncedSearchValue, setDebouncedSearchValue] = useDebounce(search, 450);
    const { teams, loading, error, initialLoading } = useTeams({ sort, search: debouncedSearchValue });
    if (searching && !loading) {
        setSearching(false);
    }
    const handleSearch = (value) => {
        setSearch(value);
        setDebouncedSearchValue(value);
        setSearching(true);
    };
    const noSearchResults = Boolean(search) && teams.length < 1;
    const value = {
        teams,
        sort,
        setSort,
        loading: initialLoading,
        error,
        searching,
        setSearch: handleSearch,
        noSearchResults,
        searchValue: search,
    };
    return <Context.Provider value={value}>{children}</Context.Provider>;
}
